import { FetchListPayload } from '../actions/fetchList';
import { PayloadApiRequest } from '../actions/sagaApi';
import { SavePayload } from '../actions/save';
import { parseDate } from '../services/datesService';

import createResource, { OptionalResource } from './createResource';
import providersResource from './providersResource';
import { EntityID, Patient } from './types';

interface PatientSearchPayload extends FetchListPayload<Patient> {
  params: {
    scope: string;
    value: string;
    type: string;
  };
}

const patientsResource = createResource<Patient>({
  key: 'patients',
  url: '/patients',
  fetchListUrl: '/patients/crudList',
  fetchPageUrl: '/patients/crudList',
  hasFetchBulkSupport: true,
  lookups: {
    primaryCareProvider: providersResource,
  },
  processStrategy: (data) => ({
    ...data,
    $dateOfBirth: parseDate(data.dateOfBirth),
  }),
});

const customActions = {
  patientSearch: (payload: OptionalResource<PatientSearchPayload>) =>
    patientsResource.fetchList({
      url: `${patientsResource.url}/search`,
      ...payload,
    }),

  verifyPatient: (id: EntityID, code: string, payload: PayloadApiRequest<Patient>) =>
    patientsResource.request({
      method: 'post',
      url: `${patientsResource.url}/${id}/verify`,
      data: { code },
      ...payload,
    }),

  login: (payload: OptionalResource<SavePayload<Patient>>) =>
    patientsResource.save({
      url: `${patientsResource.url}/login`,
      ...payload,
    }),
};

export default {
  ...patientsResource,
  ...customActions,
};
